import { NgModule } from '@angular/core';
import {
  IonApp,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuButton,
  IonModal,
  IonRouterOutlet,
  IonRow,
  IonSpinner,
  IonText,
  IonTextarea,
  IonTitle,
  IonToolbar,
} from '@ionic/angular';
import { addIcons } from 'ionicons';
import { close, closeOutline, closeSharp, trash, trashOutline, trashSharp } from 'ionicons/icons';

addIcons({
  close,
  closeOutline,
  closeSharp,
  trash,
  trashOutline,
  trashSharp,
});

/**
 * Ionic 9 removed `IonicModule` in favor of standalone components.
 * This shared module re-exports the Ionic components used across the app
 * so existing NgModules keep working with a one-line import swap.
 */
const IONIC_COMPONENTS = [
  IonApp,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuButton,
  IonModal,
  IonRouterOutlet,
  IonRow,
  IonSpinner,
  IonText,
  IonTextarea,
  IonTitle,
  IonToolbar,
];

@NgModule({
  imports: IONIC_COMPONENTS,
  exports: IONIC_COMPONENTS,
})
export class IonicSharedModule {}
